import { EVehicles } from '@enums/api.enum';

import client from '../apiClient';

export type VehicleParam = {
	id: number;
};

const endpoint = EVehicles.endpoint;

const getSingle = <T>({ id }: VehicleParam) => client.get<T>(`${endpoint}${EVehicles.single}${id}`);

export default {
	getSingle,
};
